// Configure gtag with clientId override if present
const clientIdFromQuery = new URLSearchParams(window.location.search).get("clientId");
const sessionIdFromQuery = new URLSearchParams(window.location.search).get("sessionId");

// Detect if running in mobile app wrapper
function isMobileAppWrapper() {
  const userAgent = navigator?.userAgent?.toLowerCase() || "";
  return userAgent.includes("fashionphile");
}

// Get platform from user agent
function getPlatform() {
  const userAgent = navigator?.userAgent?.toLowerCase() || "";
  if (userAgent.includes("android")) return "android";
  if (userAgent.includes("ios")) return "ios";
  return null;
}

// Get measurement ID based on platform
function getMeasurementId() {
  const platform = getPlatform();
  if (platform === "android") {
    return window?.ANDROID_MEASUREMENT_ID || "G-0TY8FHB9KW";
  } else if (platform === "ios") {
    return window?.IOS_MEASUREMENT_ID || "G-PHPFHC228N";
  }
  return window?.WEB_MEASUREMENT_ID || "G-Z56J8K6S1M";
}

// Store clientId and sessionId in localStorage and cookies for mobile app
function storeMobileAnalyticsData() {
  if (isMobileAppWrapper()) {
    if (clientIdFromQuery) {
      localStorage?.setItem("fashionphile_client_id", clientIdFromQuery);
      // Set cookie for cross-subdomain access
      if (document) {
        document.cookie = `fashionphile_client_id=${clientIdFromQuery}; path=/; domain=.fashionphile.com; max-age=31536000; SameSite=Lax`;
      }
    }
    if (sessionIdFromQuery) {
      localStorage?.setItem("fashionphile_session_id", sessionIdFromQuery);
      if (document) {
        document.cookie = `fashionphile_session_id=${sessionIdFromQuery}; path=/; domain=.fashionphile.com; max-age=31536000; SameSite=Lax`;
      }
    }
  }
}

function getClientId() {
  const clientId = clientIdFromQuery || localStorage?.getItem("fashionphile_client_id");
  if (isMobileAppWrapper() && clientId) {
    return clientId;
  }
  return null;
}

function getSessionId() {
  const sessionId = sessionIdFromQuery || localStorage?.getItem("fashionphile_session_id");
  if (isMobileAppWrapper() && sessionId) {
    return sessionId;
  }
  return null;
}

function configureGtagWithClientId() {
  if (typeof gtag !== "undefined") {
    const isMobileApp = isMobileAppWrapper();
    const measurementId = getMeasurementId();
    const clientId = getClientId();
    const sessionId = getSessionId();

    if (isMobileApp && clientId) {
      // Configure gtag with stored or query clientId/sessionId
      const config = {
        client_id: clientId,
      };

      if (sessionId) {
        config.session_id = sessionId;
      }

      gtag("config", measurementId, config);
    }
    return true; // Successfully configured
  }
  return false; // gtag not available yet
}

// Poll for gtag availability
function waitForGtag() {
  if (!configureGtagWithClientId()) {
    setTimeout(waitForGtag, 50);
  }
}

// Store mobile analytics data in localStorage if available
storeMobileAnalyticsData();

if (isMobileAppWrapper()) {
  waitForGtag();
}
